// @flow

import React from 'react';

type Props = {
  showModal: (boolean) => void,
  title: string | React.Node,
  content: React.Node,
  className?: string,
}

export default function ModalWrapper(props: Props) {
  return (
    <div className="modal-container">
      <div className={`modal${props.className ? ` ${props.className}` : ''}`}>
        <div className="modal-title">
          <span />
          {props.title}
          <i className="fa fa-times" onClick={() => props.showModal(false)} />
        </div>
        <div className="modal-content">
          {props.content}
        </div>
      </div>
    </div>
  );
}
